<template>
  <modal-container :show="show">
    <template slot="body">
      <div class="insurance_popup_wrapper p-3">
        <img
          class="cancel cursor-pointer"
          src="../../assets/images/Vector (1).png"
          alt="close"
          @click="$emit('closeBuyInsurance')"
        />

        <div class="insurance_popup_container">
          <img
            style="margin-bottom: 1rem"
            src="../../assets/images/shield with a cross.svg"
            alt=""
          />
          <h1 style="font: 600; font-size: 20px; color: rgba(64, 74, 87, 1)">
            {{this.$t("buy_ins")}}
          </h1>
          <p style="font: 400; font-size: 14px; color: rgba(94, 106, 121, 1)">
            {{this.$t("buy_ins_txt")}}
          </p>

          <div
            class="mt-2 d-flex justify-contents-between align-items-center col-gap-2 w-100"
          >
            <button
              type="button"
              class="btn btn-secondary w-100"
              @click="$emit('closeBuyInsurance')"
            >
              {{this.$t("no")}}
            </button>
            <button
              type="button"
              class="btn btn-primary w-100"
              @click="$emit('buyInsurance')"
            >
            {{this.$t("yes")}}
            </button>
          </div>
        </div>
      </div>
    </template>
  </modal-container>
</template>

<script>
import ModalContainer from "../ModalContainer.vue";
export default {
  components: { ModalContainer },
  name: "InsurancePopup",
  props: {
    show: Boolean,
  },
};
</script>

<style scoped>
.insurance_popup_wrapper {
  margin: 0 auto;
  background: white;
  max-width: 500px;
  height: 450px;
  border-radius: 1rem;
  border-radius: 1rem;
}
.insurance_popup_container {
  width: 340px;
  margin: 3rem auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.cancel {
  display: block;
  margin-left: auto; /* Moves the icon to the right */
}
</style>
